export class PodValidationWidgetChepManagerData {
  podCountByRegion: RegionPodCount[];

  static fromDto(data: any): PodValidationWidgetChepManagerData {
    if (data === null) {
      return null;
    }

    const res = new PodValidationWidgetChepManagerData();

    res.podCountByRegion = data.pod_count_by_region.map(regionPodCount => RegionPodCount.fromDto(regionPodCount));

    return res;
  }
}

export class RegionPodCount {
  count: number;
  regionName: string;
  regionId: string;

  static fromDto(data: any): RegionPodCount {
    if (data === null) {
      return null;
    }

    const res = new RegionPodCount();

    res.regionId = data.region_id;
    res.regionName = data.region_name;
    res.count = data.count;

    return res;
  }
}
